































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {CursorDiagramModeManager} from '@/logic/cursorDiagramModeManager';
import {DiagramModule} from '@/store/modules/diagramModule';
import {DiagramSyncMode} from './interfaces';
import {union} from 'lodash';

@Component({components: {SelectionList}})
export default class SyncMenuButton extends Vue {
  // Список идентификаторов режимов синхронизации
  selectedSyncModeIds: any[] = [];

  // Список режимов синхронизации
  get syncModes() {
    return [...this.diagramSyncModes];
  }

  // Список идентификаторов выбранных диаграмм
  selectedDiagramIds: any[] = [];

  // Список графиков для синхронизации
  get diagrams() {
    return [
      ...this.diagramStoreModule.diagrams.filter(x => x.id !== this.diagramId),
    ].map((d: any) => ({...d, name: d.name.replace(/\s*оси\s+[XYZ]\s*/i, ' ').trim()}));
  }

  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  @Prop({required: true, type: String})
  icon!: string;

  @Prop({required: true})
  diagramId!: string;

  //null для исправления бага
  activeState: number | undefined | null = null;

  @Prop({required: true})
  applyStatus!: boolean;

  @Prop({required: true})
  modeManager!: CursorDiagramModeManager;

  @Prop({required: true})
  diagramStoreModule!: DiagramModule;

  @Prop({required: true})
  diagramSyncModes!: DiagramSyncMode[];

  menu = false;

  key = 0;

  @Watch('menu')
  bugFix(value: boolean) {
    if (!value) {
      this.activeState = null;
      this.key++;
    } else {
      //устанавливаем на основе стора чекбоксы
      this.selectedSyncModeIds = union(
        this.syncModes.filter(x => x.preselected).map(x => x.id),
        this.diagramStoreModule.syncModes.map(x => x.id),
      );

      this.selectedDiagramIds = this.diagramStoreModule.syncDiagrams
        .map(x => x.id)
        .filter(x => x !== this.diagramId);
    }
  }

  @Prop({type: Boolean, default: false})
  disabled!: string;

  @Prop({default: () => ({})})
  activators!: {};

  click(e: any) {
    this.menu = false;

    const diagrams = this.diagramStoreModule.diagrams.filter(
      x => this.selectedDiagramIds.includes(x.id) || x.id === this.diagramId,
    );

    this.diagramStoreModule.setSyncSettings({
      syncDiagrams: diagrams,
      syncModes: this.syncModes.filter(x => this.selectedSyncModeIds.includes(x.id)),
      syncedState: this.modeManager.getState(),
    });

    this.$emit('click', e);
  }

  change() {
    this.$emit('change', this.activeState);
  }
}
